import { useDispatch } from 'react-redux';
import { useCallback, useContext } from 'react';

// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import StyleBreakPointsControlsContainer from 'ContentEditorUI/containers/StyleBreakPointsControlsContainer';
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import EditorActionsAndEventsContext from 'ContentEditorUI/context/EditorActionsAndEventsContext';
import { setDirtyFlag, setIframeLoading
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
} from 'ContentEditorUI/redux/actions/appActions';
import { fetchPageCssAssets } from 'ContentEditorUI/redux/actions/contentAssetsActions';
import { jsx as _jsx } from "react/jsx-runtime";
const BreakpointsContainer = () => {
  const dispatch = useDispatch();
  const {
    saveActions
  } = useContext(EditorActionsAndEventsContext);
  const bus = window.hubspot.ContentEditorUI.eventBus;
  const refreshPreview = useCallback(() => {
    dispatch(setIframeLoading());
    saveActions.autoSave().then(() => {
      dispatch(fetchPageCssAssets());
      bus.trigger('preview:refresh');
    }).catch(e => {
      console.error(e);
    });
  }, [dispatch, bus, saveActions]);
  const handleApplyChanges = useCallback(() => {
    dispatch(setDirtyFlag(true));
    refreshPreview();
  }, [dispatch, refreshPreview]);
  return /*#__PURE__*/_jsx(StyleBreakPointsControlsContainer, {
    toggleModuleEditSidebarCallback: handleApplyChanges
  });
};
export default BreakpointsContainer;